// -----------------  FETCH HOME SECTIONS -----------------
export const FETCH_HOME_SECTIONS_LOADING = 'FETCH_HOME_SECTIONS_LOADING';
export const FETCH_HOME_SECTIONS_SUCCESS = 'FETCH_HOME_SECTIONS_SUCCESS';
export const FETCH_HOME_SECTIONS_ERROR = 'FETCH_HOME_SECTIONS_ERROR';
